"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputAxis = void 0;
const KHEventHandler_1 = require("../KHEventHandler");
/**
 * Input axis that specifies the state of one axis. Managers of this axis must
 * update it once and only once per frame, or strange behavior can occur.
 */
class KHInputAxis extends KHEventHandler_1.KHEventHandler {
    constructor() {
        super([KHInputAxis.EVENT_AXIS_UPDATE]);
        this.value = 0;
    }
    /**
     * Updates the axis value to the value passed in. Returns whether or not
     * the value changed.
     */
    update(value) {
        let changed = this.value != value;
        this.lastValue = this.value;
        this.value = value;
        if (changed) {
            this.emitEvent(KHInputAxis.EVENT_AXIS_UPDATE, null);
        }
        return changed;
    }
    getValue() {
        return this.value;
    }
    getLastValue() {
        return this.lastValue;
    }
    changed() {
        return this.value != this.lastValue;
    }
}
exports.KHInputAxis = KHInputAxis;
KHInputAxis.EVENT_AXIS_UPDATE = "au";
